import React from 'react';
import Link from 'gatsby-link';

import Align from '@marvelapp/marvel-ui/align';
import Button from '@marvelapp/marvel-ui/button';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import MediaMultipleImages from 'marketing-website/components/modules/Media/MediaMultipleImages';
import ParallaxWrapper from 'marketing-website/components/wrappers/ParallaxWrapper';

import assets from 'marketing-website/configs/pages/why-marvel/assets.js';

export default function Interactive() {
  return (
    <div className="shape bg-orange--l">
      <PageWrap size="l">
        <Spacing size="xl" type="padding" position="topBottom">
          <Grid columns={12} alignItems="center">
            <GridItem columnSpan={12} columnSpanM={7}>
              <MediaMultipleImages
                fallbackImageAlt="Interactive prototypes will reinvent how you showcase design work"
                fallbackImageMaxWidth={686}
                fallbackImageSrc={assets.interactive.src}
              >
                <ParallaxWrapper speed={1.6}>
                  <Image
                    {...assets.pattern}
                    hasShadow={false}
                    maxWidth={380}
                    position="absolute"
                    top="auto"
                    left="auto"
                    right="20%"
                    bottom="10%"
                  />
                </ParallaxWrapper>
                <ParallaxWrapper>
                  <div className="opacity-50">
                    <Image
                      {...assets.people}
                      borderRadius="m"
                      left="6%"
                      maxWidth={380}
                      position="absolute"
                      top="20%"
                    />
                  </div>
                </ParallaxWrapper>
                <ParallaxWrapper speed={1.6}>
                  <Image
                    {...assets.photos}
                    borderRadius="m"
                    left="21%"
                    maxWidth={380}
                    position="absolute"
                    top="36%"
                  />
                </ParallaxWrapper>
                <ParallaxWrapper speed={2}>
                  <Image
                    {...assets.buttons}
                    borderRadius="m"
                    hasShadow={false}
                    maxWidth={210}
                    position="absolute"
                    top="62%"
                  />
                </ParallaxWrapper>
              </MediaMultipleImages>
            </GridItem>
            <GridItem columnSpan={12} columnSpanM={5}>
              <Spacing size="m" type="margin" position="bottom">
                <HeadingBlock
                  color="white"
                  justifyContent="center"
                  justifyM="start"
                  maxWidth={460}
                  title="Reinvent how you present design work"
                  copy={
                    <span>
                      The days of static designs, slide decks and email
                      attachments to present work are over. Transform how you
                      share work by showcasing interactive Marvel prototypes.{' '}
                      <br /> <br />
                      User journeys and site hierarchy can be difficult to
                      explain, Marvel takes the complexity out of it by showing
                      your audience realistic interactions. With no coding
                      required, we make design simple, for everyone.
                    </span>
                  }
                />
              </Spacing>
              <Align type="center" typeM="left">
                <Link to="/features/prototyping">
                  <Button
                    background="white"
                    hover="blue"
                    color="slate"
                    shape="rounded"
                    size="large"
                  >
                    Learn more
                  </Button>
                </Link>
              </Align>
            </GridItem>
          </Grid>
        </Spacing>
      </PageWrap>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/why-marvel/Interactive.js